import script from "./NodeShareModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NodeShareModal.vue?vue&type=script&setup=true&lang=ts"

import "./NodeShareModal.vue?vue&type=style&index=0&id=796b241d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796b241d"]])

export default __exports__